// extracted by mini-css-extract-plugin
module.exports = {"item":"item-module--item--2YuDA","logo":"item-module--logo--3jPDI"};